import * as React from 'react';

export const Document2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M20.108 0l8.283 8.463-.001 1.131v19.52a2.885 2.885 0 0 1-2.717 2.881l-.17.005H6.887a2.886 2.886 0 0 1-2.882-2.716L4 29.114V2.909A2.885 2.885 0 0 1 6.717.028l.17-.004h12.09L20.108 0zm-1.13 2.59H6.886a.321.321 0 0 0-.315.254l-.007.064v26.207c0 .154.11.283.257.313l.065.006h18.617c.154 0 .284-.11.314-.255l.006-.064V9.595h-6.847V2.589zm2.355 18.743v1.334H10.667v-1.334h10.666zm0-4v1.334H10.667v-1.334h10.666zm-5.333-4v1.334h-5.333v-1.334H16z"
    />
  </svg>
);
